var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'background-color': _vm.bgcolors}),attrs:{"id":"overlay-dots"}},[_c('div',{staticClass:"loader-dots",style:({'color': _vm.object,'font-size': _vm.size+'px'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }